import React, { useState, useMemo, useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogActions,
  Button,
} from "@fluentui/react-components";
import "react-quill/dist/quill.bubble.css";
import "./style.css";

interface ReactQuillComponentProps {
  value: string;
}

const ReactQuillComponent = ({ value }: ReactQuillComponentProps) => {
  const [open, setOpen] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const previewRef = useRef<HTMLDivElement>(null);

  const sanitizedHtml = useMemo(() => DOMPurify.sanitize(value), [value]);

  // ✅ Check if the content exceeds its container (i.e. line-clamped)
  useEffect(() => {
    const el = previewRef.current;
    if (el) {
      const isClamped = el.scrollHeight > el.clientHeight + 1; // small tolerance
      setIsOverflowing(isClamped);
    }
  }, [sanitizedHtml]);

  return (
    <>
      <div className="note-preview-wrapper">
        <div
          ref={previewRef}
          className="note_lineClamp"
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
        {isOverflowing && (
          <span className="view-more-link" onClick={() => setOpen(true)}>
            View more
          </span>
        )}
      </div>

      <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
        <DialogSurface style={{ minHeight: "fit-content" }}>
          <DialogBody style={{ display: "flex", flexDirection: "column" }}>
            <div
              className="dialog_content ql-editor"
              dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
            />
          </DialogBody>
          <DialogActions>
            <Button appearance="secondary" onClick={() => setOpen(false)}>
              Close
            </Button>
          </DialogActions>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default ReactQuillComponent;
